//
// Single source of truth for the SESSION-OBJECT alias grammar (F2.1). Mirrors the
// server validator in blobhub-infra (api/workflows/processors/persistence.py).
// NOTE: this is NOT the org/user/blob handle or workflow-definition grammar — do
// not reuse it for those inputs.

export const SESSION_OBJECT_ALIAS_MIN_LENGTH = 1;
export const SESSION_OBJECT_ALIAS_MAX_LENGTH = 256;

// Anchored form for programmatic checks.
export const SESSION_OBJECT_ALIAS_PATTERN = /^[A-Za-z0-9._@-]+(\/[A-Za-z0-9._@-]+)*$/;

// Unanchored body for an HTML5 `pattern` attribute (the browser anchors it as ^(?:…)$).
// The "."/".." segment rule is NOT expressible here; validateSessionObjectAlias enforces it.
export const SESSION_OBJECT_ALIAS_HTML5_PATTERN = "[A-Za-z0-9._@-]+(/[A-Za-z0-9._@-]+)*";

const RESERVED_SEGMENTS = new Set([".", ".."]);

export function validateSessionObjectAlias(alias) {
  if (typeof alias !== "string") {
    return "Session object alias must be a string.";
  }
  if (alias.length < SESSION_OBJECT_ALIAS_MIN_LENGTH || alias.length > SESSION_OBJECT_ALIAS_MAX_LENGTH) {
    return `Session object alias must be ${SESSION_OBJECT_ALIAS_MIN_LENGTH}–` +
      `${SESSION_OBJECT_ALIAS_MAX_LENGTH} characters.`;
  }
  if (!SESSION_OBJECT_ALIAS_PATTERN.test(alias)) {
    return "Session object alias may contain only letters, digits, . _ @ - and / as a path separator.";
  }
  if (alias.split("/").some((segment) => RESERVED_SEGMENTS.has(segment))) {
    return "Session object alias may not contain \".\" or \"..\" path segments.";
  }
  return null;
}

export function isValidSessionObjectAlias(alias) {
  return validateSessionObjectAlias(alias) === null;
}
